<template>
  <v-bottom-sheet v-model="isSearchFilterMobile">
    <v-sheet tile color="white">
      <!-- HEADER -->
      <div class="d-flex justify-space-between align-center pa-4 px-6">
        <div>
          <span class="text-h6 font-weight-bold">
            Filtres
          </span>
          <div v-if="!searchLoading" class="text-body-2 text--secondary">
            {{ resultToDisplay }}
          </div>
          <v-skeleton-loader
            v-else
            type="heading"
            width="240px"
          ></v-skeleton-loader>
        </div>

        <v-btn @click="closeBottomSheet()" icon large>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <!-- FILTERS -->
      <v-sheet
        v-if="themesByCategoryLoading"
        class="d-flex px-6 py-4 scroll--overflow-x"
        color="grey lighten-4"
      >
        <BaseSelectorLoading
          v-for="n in 6"
          :key="n"
          class="mr-4"
          buttonSize="large"
        ></BaseSelectorLoading>
      </v-sheet>
      <v-sheet
        v-else
        class="d-flex px-6 py-4 scroll--overflow-x"
        color="grey lighten-4"
      >
      <!-- Ambiances Theme -->
        <BaseSelector
          class="mr-4"
          :name="ambiancesThemes.nameFr"
          :multiple="true"
          :options="ambiancesThemes.themes"
          :value="search.ambiances"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              ambiancesThemes.nameEn
            )
          "
          :attached="false"
        ></BaseSelector>
        <!-- Activities Theme -->
        <BaseSelector
          class="mr-4"
          :name="activitiesThemes.nameFr"
          :multiple="true"
          :options="activitiesThemes.themes"
          :value="search.activities"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              activitiesThemes.nameEn
            )
          "
          :attached="false"
        ></BaseSelector>
        <!-- Travellers Theme -->
        <BaseSelector
          class="mr-4"
          :name="travellersThemes.nameFr"
          :multiple="true"
          :options="travellersThemes.themes"
          :value="search.travellers"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              travellersThemes.nameEn
            )
          "
          :attached="false"
        ></BaseSelector>
        <!-- Transports Theme -->
        <BaseSelector
          class="mr-4"
          :name="transportsThemes.nameFr"
          :multiple="true"
          :options="transportsThemes.themes"
          :value="search.transports"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              transportsThemes.nameEn
            )
          "
          :attached="false"
        ></BaseSelector>
        <!-- Seasons Selector -->
        <BaseSelector
          class="mr-4"
          :name="$t(`core.seasons.plural_SEASON`)"
          :multiple="true"
          :options="seasons.options"
          :value="seasons.value"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              'seasons'
            )
          "
          :attached="false"
        ></BaseSelector>
        <!-- Media Selector -->
        <BaseSelector
          class="mr-4"
          :name="$t(`core.media.name`)"
          :multiple="true"
          :options="media.options"
          :value="media.value"
          :oneValueRequired="false"
          :styleIsActiveIfValueEgalOptions="true"
          buttonSize="large"
          @updateValue="
            updateParameter(
              $event.map(x => x.nameEn),
              'media'
            )
          "
          :attached="false"
        ></BaseSelector>
      </v-sheet>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
//COMPONENTS
import BaseSelectorLoading from "./../../core/components/BaseSelectorLoading";
//VARIABLES
import seasons from "./../../core/variables/seasons.json";
import media from "./../../core/variables/media.json";
// MIXINS
import ThemesByCategoryMixin from "../../core/mixins/ThemesByCategoryMixin";
// MODULES
import { mapState } from "vuex";
export default {
  name: "SearchFiltersMobile",
  components: {
    BaseSelectorLoading
  },
  // MIXINS
  mixins: [ThemesByCategoryMixin],
  // DATAs
  props: {
    search: { type: Object, required: true },
    resultToDisplay: { type: String, default: () => "" }
  },
  computed: {
    ...mapState({
      searchLoading: state => state.search.searchLoading
    }),
    themesCategories() {
      return [
        {
          name: activities.name,
          options: activities.themes,
          value: this.search.activities
        },
        {
          name: ambiances.name,
          options: ambiances.themes,
          value: this.search.ambiances
        },
        {
          name: transports.name,
          options: transports.themes,
          value: this.search.transports
        },
        {
          name: travellers.name,
          options: travellers.themes,
          value: this.search.travellers
        }
      ];
    },
    seasons() {
      return {
        name: "seasons",
        options: seasons,
        value: this.search.seasons
      };
    },
    media() {
      return {
        name: "media",
        options: media,
        value: this.search.media
      };
    }
  },
  data() {
    return {
      isSearchFilterMobile: false
    };
  },
  methods: {
    updateParameter(value, parameter) {
      this.$emit("updateParameter", { value: value, parameter: parameter });
    },
    openBottomSheet() {
      this.isSearchFilterMobile = true;
    },
    closeBottomSheet() {
      this.isSearchFilterMobile = false;
    }
  }
};
</script>

<style scoped></style>
